import { referralApi } from "../../services/referralService";
import {AsyncSelectField} from "./asyncSelectField"

export const IcdSearch = ({
  title = "Diagnosis",
  defaultInputValue = "",
  showLabel = "short_desc",
  onSelection,
  pid,
  ...props
}) => {
  const [searchIcd] = referralApi.endpoints.searchIcd.useLazyQuery();
  const search = async (query) => {
    const response = await searchIcd(
      pid ? { keyword: query, pid: pid } : query
    );

    const res = response?.data?.map((data) => {
      return data;
    });

    return new Promise(function (resolve, reject) {
      resolve(res || []);
    });
  };
  const CustomOption = (props) => {
    const { innerProps, isDisabled, label, value } = props;
    return (
      <div
        {...innerProps}
        className={`${(props?.data?.code_system == 'icd9') ? 'w-full px-3 py-2 select__option select__option--is-disabled opacity-50' : 'w-full px-3 py-2 font-11 cursor-pointer hover:bg-blue-200'} ${props?.data?.linked_with_encounter && "font-bold"}`}
      >
        <span>{props?.data?.code}</span> - <span>{props?.data?.short_desc ? props?.data?.short_desc : props?.data?.name}</span>
      </div>
    );
  };
  const getOptionLabel = item => {
    return `${item.code} - ${item.short_desc}`;
  }
  return (
    <AsyncSelectField CustomOption={CustomOption} showLabel={showLabel} getOptionLabel={getOptionLabel} title={title} search={(query) => search(query)} {...props} />
  );
};
